import React from 'react';
import { FormattedMessage } from 'react-intl';

const translate = (id: string, value = {}) =>
    <FormattedMessage id={id} values={{...value, b: (chunk: React.ReactNode) => <b>{chunk}</b>}}/>;

export default translate;
